import { BASE_URL } from 'config/urls';

import { callUrl, get } from 'utils/sdk';

export const getSchoolNameFromIdentifier = (schoolIdentifier) =>
  callUrl(get, `${BASE_URL}/v1/schools/get-name/${schoolIdentifier}/`);
